import BigNumber from 'bignumber.js'
import { VVS_PER_YEAR } from 'config'
import { getBalanceAmount } from './formatBalance'

/**
 * Get vvs token farm rewards per day
 * @param poolWeight allocationPoint / totalAllocationPoint
 * @returns vvs reward per day
 */
export const getVVSRewardPerDay = (poolWeight: BigNumber): number => {
  const yearlyVvsRewardAllocation: BigNumber = poolWeight ? poolWeight.times(VVS_PER_YEAR) : new BigNumber(NaN)
  return yearlyVvsRewardAllocation.div(365).toNumber()
}

/**
 * Get token farm rewards per day
 * @param rewardPerSecond
 * @param rewardStartTimestamp
 * @param rewardEndTimestamp
 * @returns token reward per day
 */
export const getTokenRewardPerDay = (
  rewardPerSecond: BigNumber,
  rewardStartTimestamp: number,
  rewardEndTimestamp: number,
): number => {
  const now: number = Date.now()
  if (now < rewardStartTimestamp || now > rewardEndTimestamp) {
    return 0
  }
  return rewardPerSecond.times(86400).toNumber()
}

/**
 * Get token rewards apr
 * @param tokenAddress token address
 * @param tokenDecimals token decimals
 * @param totalRewardPerSecond
 * @param rewardStartTimestamp
 * @param rewardEndTimestamp
 * @param allocPoint allocation point of this token to this farm
 * @param totalAllocPoint
 * @param poolLiquidityUsd total liquidity in this farm
 * @param farms a temperary way to get token price
 * @returns token reward apr
 */
export const getTokenRewardApr = (
  tokenAddress: string,
  tokenDecimals: number,
  totalRewardPerSecond: string,
  rewardStartTimestamp: string,
  rewardEndTimestamp: string,
  allocPoint: string,
  totalAllocPoint: string,
  poolLiquidityUsd: BigNumber,
  farms: any[],
): number => {
  const now: number = Date.now() / 1000
  if (now < parseInt(rewardStartTimestamp) || now > parseInt(rewardEndTimestamp)) {
    return 0
  }
  const weight: BigNumber = new BigNumber(allocPoint).div(totalAllocPoint)
  const yearlyReward: BigNumber = getBalanceAmount(new BigNumber(totalRewardPerSecond), tokenDecimals)
    .times(86400)
    .times(365)
  const rewardAllocation: BigNumber = weight.times(yearlyReward)

  // token price
  const getFarm = farms.find((farm) => farm.token.address === tokenAddress)
  const tokenPriceUsd: string = getFarm ? getFarm.tokenPriceUsdc : 'NaN'

  const tokenRewardsUsd = rewardAllocation.times(tokenPriceUsd)
  const tokenRewardsApr: BigNumber = tokenRewardsUsd.div(poolLiquidityUsd).times(100)

  let tokenRewardsAprAsNumber = null
  if (!tokenRewardsApr.isNaN() && tokenRewardsApr.isFinite()) {
    tokenRewardsAprAsNumber = tokenRewardsApr.toNumber()
  }
  return tokenRewardsAprAsNumber
}

export default null
